<template>
  <div>
    <div v-if="image.preview" class="preview-box">
      <img class="preview-img" :src="image.preview" />
      <div class="preview-footer">
        <div class="name v-ellipsis">{{ image.name }}</div>
        <i @click.stop="openWindow(image.preview)" class="operate-btn el-icon-zoom-in"></i>
        <i @click.stop="deleteImage" class="operate-btn el-icon-delete"></i>
      </div>
    </div>

    <div v-if="!image.preview" @click="chooseImage" class="upload-btn v-col v-center" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0)">
      <i class="icon el-icon-plus"></i>
    </div>

    <upload-dialog v-if="isShowUploadDialog" :show.sync="isShowUploadDialog" type="image" @change="handleChange"></upload-dialog>
  </div>
</template>

<script>
import uploadDialog from './components/upload-dialog';

export default {
  components: { uploadDialog },

  props: ['id'],

  model: {
    prop: 'id',
    event: 'change',
  },

  data() {
    return {
      image: {},
      loading: false,
      isShowUploadDialog: false,
    };
  },

  created() {
    if (this.id) {
      this.getPreview();
    }
  },

  watch: {
    id: function(val) {
      if (typeof val == 'number' && val) {
        this.getPreview();
      }
    },
  },

  methods: {
    //根据id获取素材
    async getPreview() {
      this.loading = true;
      try {
        let res = await this.api.media.getPreview({ ids: [this.id] });
        this.image = res.data[this.id];
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    chooseImage() {
      this.isShowUploadDialog = true;
    },

    //删除
    deleteImage() {
      this.image = {};
      this.$emit('change', '');
    },

    handleChange(images) {
      let { key, preview, name, id } = images[0];
      this.image = { key, preview, name, id };
      this.$emit('change', id);
    },

    openWindow(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-btn {
  border: 1px dashed #9a9a9a;
  border-radius: 4px;
  cursor: pointer;
  color: #9a9a9a;
  justify-content: center;
  box-sizing: border-box;
  margin: 0 10px 10px 0;
  width: 150px;
  height: 150px;

  .icon {
    font-size: 22px;
  }

  .txt {
    font-size: 12px;
  }
}

.preview-box {
  position: relative;
  line-height: 1;
  background: #eee;
  width: 150px;

  .preview-img {
    display: block;
    border-radius: 4px;
    width: 150px;
    height: 150px;
  }

  .preview-footer {
    display: flex;
    font-size: 12px;
    height: 25px;
    line-height: 25px;
    background: rgba(0, 0, 0, 0.3);
    color: #fff;
    align-items: center;
    transition: all 0.3s ease;
  }

  .preview-footer .name {
    flex: 1;
    font-size: 12px;
    padding: 0 10px;
    height: 25px;
  }

  .preview-footer .operate-btn {
    color: #fff;
    margin-right: 10px;
    cursor: pointer;
    line-height: 25px;
  }
}
</style>
